var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H17C17.5523 3 18 2.55228 18 2C18 1.44772 17.5523 1 17 1H7C6.44772 1 6 1.44772 6 2C6 2.55228 6.44772 3 7 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 8.55228 6.44772 9 7 9H17C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7H7C6.44772 7 6 7.44772 6 8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.89543 6 0 6.89543 0 8C0 9.10457 0.89543 10 2 10Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H10C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C3.10457 16 4 15.1046 4 14C4 12.8954 3.10457 12 2 12C0.89543 12 0 12.8954 0 14C0 15.1046 0.89543 16 2 16Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.552C24 19.534 24 19.518 24 19.5V12.705C24 12.1101 23.7353 11.5461 23.2775 11.1661C22.8198 10.7861 22.2167 10.6295 21.632 10.739L15.632 11.864C14.6857 12.0411 13.9999 12.8673 14 13.83V18.761C13.9996 18.8312 13.9703 18.8981 13.919 18.946C13.8668 18.9933 13.7971 19.0166 13.727 19.01C13.652 19 13.577 19 13.5 19C12.1261 19.0003 11.0099 20.1092 11.0006 21.483C10.9913 22.8569 12.0923 23.9808 13.466 23.9998C14.8398 24.0187 15.9714 22.9256 16 21.552C16 21.534 16 21.518 16 21.5V14.245C16.0002 14.0045 16.1716 13.7982 16.408 13.754L21.408 12.816C21.5543 12.7886 21.7051 12.8278 21.8196 12.9229C21.934 13.018 22.0002 13.1592 22 13.308V16.761C21.9996 16.8312 21.9703 16.8981 21.919 16.946C21.8668 16.9933 21.7971 17.0166 21.727 17.01C21.652 17 21.577 17 21.5 17C20.1261 17.0003 19.0099 18.1092 19.0006 19.483C18.9913 20.8569 20.0923 21.9808 21.466 21.9998C22.8398 22.0187 23.9714 20.9256 24 19.552Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.d8dc3fe7.svg";
export { ForwardRef as ReactComponent };